// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

import { ApizConfig } from './environment.model';

export const environment: ApizConfig = {
  basehref: '/',
  configUrl: 'https://config-server.lpfnew.dev-k8s.apizsolutions.com/master/iupics-config-default.json',
  production: true,
  appName: 'Apiz',
  CUST_version: 'hotfix/3.3.3-b42b65ab',
  STD_version: '6.2.1',
  default_language: 'fr_FR',
  webSiteUrl: 'https://lpfnew.dev-k8s.apizsolutions.com/',
  available_languages: ['ar_TN', 'ca_ES', 'en_GB', 'en_US', 'en', 'es_ES', 'fr_FR', 'fr', 'nl_NL'],
  config: {
    perfLogActive: false,
    backend: {
      ws: {
        url: 'https://ws.lpfnew.dev-k8s.apizsolutions.com',
      },
      auth: {
        url: 'https://keycloak.lpfnew.dev-k8s.apizsolutions.com',
        realm: 'apiz',
        clientId: 'iupics',
      },
      socketcluster: {
        hostname: 'https://socket.lpfnew.dev-k8s.apizsolutions.com',
        port: undefined,
        secure: true,
      },
    },
  },
  constant: null,
  themes: null,
};
